document.querySelectorAll('dialog-component[id^="b2b-video-modal-"]').forEach(function(modal) {
  var video = modal.querySelector('video');
  var iframe = modal.querySelector('.b2b-video__modal-iframe');
  var inner = modal.querySelector('.b2b-video__modal-inner');

  modal.addEventListener('dialog:open', function() {
    if (iframe) {
      iframe.src = iframe.dataset.src;
    } else if (video) {
      video.currentTime = 0;
      video.play();
    }
  });

  modal.addEventListener('dialog:close', function() {
    if (iframe) {
      iframe.src = '';
    } else if (video) {
      video.pause();
    }
  });

  modal.addEventListener('click', function(e) {
    if (inner && !inner.contains(e.target)) {
      modal.closeDialog();
    }
  });
});
